import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOnlineStatus } from '../actions/pwa';

export const useNetworkStatus = () => {
  const dispatch = useDispatch();
  const isOnline = useSelector((state) => state.pwa.isOnline);

  useEffect(() => {
    const handleOnline = () => {
      console.log('Network: Back online');
      dispatch(setOnlineStatus(true));
    };

    const handleOffline = () => {
      console.log('Network: Connection lost');
      dispatch(setOnlineStatus(false));
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Set initial status
    dispatch(setOnlineStatus(navigator.onLine));

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [dispatch]);

  return isOnline;
};
